export enum Direction {
    UP = "UP", DOWN = "DOWN", BOTH="BOTH"
}

export enum SortBy {
    ASCENDING = "asc",
    DESCENDING = "desc",
    NONE = "none"
}

export interface IDirectionalToggle {
    direction: Direction;
    sortAscending: () => void;
    sortDescending: () => void;
    text?: string 
    defaultSort?: SortBy
    onRemoveDefaultSort?:() => void
}

